import { podcastOwnershipClaim, PodcastOwnershipResponse } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ownedPodcastQueries } from './queryKeys';

type QueryKey = ReturnType<typeof ownedPodcastQueries.podcast>;

export function useGetPodcastOwnership<TData = PodcastOwnershipResponse>(
  id?: string,
  opts?: Omit<
    UseQueryOptions<PodcastOwnershipResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<PodcastOwnershipResponse, unknown, TData, QueryKey>(
    ownedPodcastQueries.podcast(id as string),

    ({ queryKey }) =>
      podcastOwnershipClaim({
        podcastId: queryKey[0].podcastId,
        initiateOwnershipRequest: false,
      }),
    { enabled: !!id, ...opts },
  );
}
